const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || `${window.location.protocol}//${window.location.host}/api/v1`,

  ENDPOINTS: {
    AUTH: {
      SIGNUP: '/auth/signup',
      LOGIN: '/auth/login',
      SEND_OTP: '/auth/mobile-otp',
      VERIFY_OTP: '/auth/verify-otp',
      FORGOT_PASSWORD: '/auth/forgot-password',
      RESET_PASSWORD: '/auth/reset-password',
      REFRESH: '/auth/refresh',
      LOGOUT: '/auth/logout',
      SOCIAL_LOGIN: '/auth/social-login',
    },
    EVENTS: {
      BASE: '/events',
      BY_ID: (id) => `/events/${id}`,
      REGISTER: (id) => `/events/${id}/register`,
      REGISTER_INITIATE: (id) => `/events/${id}/register/initiate`,
      REGISTER_CONFIRM: (id) => `/events/${id}/register/confirm`,
      REGISTRATIONS: (id) => `/events/${id}/registrations`,
      SPONSOR_CONFIG: (id) => `/events/${id}/sponsor/config`,
      SPONSOR_INITIATE: (id) => `/events/${id}/sponsor/initiate`,
      SPONSOR_CONFIRM: (id) => `/events/${id}/sponsor/confirm`,
      SPONSORSHIPS: (id) => `/events/${id}/sponsorships`,
    },
    TEAMS: {
      BASE: '/teams',
      BY_ID: (id) => `/teams/${id}`,
      MY: '/teams/my',
      LEADERBOARD: '/teams/leaderboard',
      MEMBERS: (teamId) => `/teams/${teamId}/members`,
      MEMBER: (teamId, userId) => `/teams/${teamId}/members/${userId}`,
      REVIEWS: (teamId) => `/teams/${teamId}/reviews`,
      REVIEW_BY_ID: (teamId, reviewId) => `/teams/${teamId}/reviews/${reviewId}`,
      REVIEW_SUMMARY: (teamId) => `/teams/${teamId}/reviews/summary`,
      SPONSOR_INITIATE: (teamId) => `/teams/${teamId}/sponsor/initiate`,
      SPONSOR_CONFIRM: (teamId) => `/teams/${teamId}/sponsor/confirm`,
      SPONSORSHIPS: (teamId) => `/teams/${teamId}/sponsorships`,
      SPONSOR_BALANCE: (teamId) => `/teams/${teamId}/sponsor/balance`,
      BANK_ACCOUNT: '/teams/bank-account',
      WITHDRAW: (teamId) => `/teams/${teamId}/withdraw`,
      WITHDRAWALS: (teamId) => `/teams/${teamId}/withdrawals`,
      GUEST_MEMBERS: (teamId) => `/teams/${teamId}/guest-members`,
      GUEST_MEMBER: (teamId, guestId) => `/teams/${teamId}/guest-members/${guestId}`,
      GUEST_MEMBER_LINK: (teamId, guestId) => `/teams/${teamId}/guest-members/${guestId}/link`,
    },
    MATCHES: {
      BASE: '/matches',
      BY_ID: (id) => `/matches/${id}`,
      BY_EVENT: (eventId) => `/matches/event/${eventId}`,
      SCORE: (id) => `/matches/${id}/score`,
      LIVE: '/matches/live',
    },
    USERS: {
      PROFILE: '/users/profile',
      ROLES: '/users/roles',
      BY_ID: (id) => `/users/${id}`,
      SEARCH: '/users/search',
    },
    DIARY: {
      BASE: '/users/diary',
      BY_ID: (id) => `/users/diary/${id}`,
    },
    MEDIA: {
      BY_EVENT: (eventId) => `/events/${eventId}/media`,
      BY_ID: (eventId, mediaId) => `/events/${eventId}/media/${mediaId}`,
    },
    REVIEWS: {
      BY_EVENT: (eventId) => `/events/${eventId}/reviews`,
      BY_ID: (eventId, reviewId) => `/events/${eventId}/reviews/${reviewId}`,
      SUMMARY: (eventId) => `/events/${eventId}/reviews/summary`,
    },
    COACHES: {
      BASE: '/coaches',
      BY_ID: (id) => `/coaches/${id}`,
      ME: '/coaches/me',
      SESSIONS: (coachId) => `/coaches/${coachId}/sessions`,
      ALL_SESSIONS: '/sessions',
      SESSION_BY_ID: (id) => `/sessions/${id}`,
      ENROLL: (sessionId) => `/sessions/${sessionId}/enroll`,
      SESSION_ENROLLMENTS: (sessionId) => `/sessions/${sessionId}/enrollments`,
      ENROLLMENT_BY_ID: (sessionId, enrollId) => `/sessions/${sessionId}/enrollments/${enrollId}`,
      MY_ENROLLMENTS: '/coaches/my-enrollments',
    },
    LINEUPS: {
      BASE: '/lineups',
      BY_ID: (id) => `/lineups/${id}`,
    },
    CONFIG: '/config',
    STATS: {
      PARTICIPANT: '/users/stats/participant',
      ORGANIZER: '/users/stats/organizer',
      SPONSOR: '/users/stats/sponsor',
      PAST_EVENTS: '/users/stats/participant/past-events',
      ORGANIZER_PAST_EVENTS: '/users/stats/organizer/past-events',
      SPONSOR_PAST_EVENTS: '/users/stats/sponsor/past-events',
    },
    SOCIAL: {
      POSTS: '/social/posts',
      POSTS_MEDIA: '/social/posts/media',
      POST_BY_ID: (id) => `/social/posts/${id}`,
      POST_LIKE: (id) => `/social/posts/${id}/like`,
      USER_POSTS: (userId) => `/social/users/${userId}/posts`,
      COMMENTS: (postId) => `/social/posts/${postId}/comments`,
      COMMENT_BY_ID: (id) => `/social/comments/${id}`,
      COMMENT_LIKE: (id) => `/social/comments/${id}/like`,
      BOOKMARK: (postId) => `/social/posts/${postId}/bookmark`,
      BOOKMARKS: '/social/bookmarks',
      FOLLOW: (userId) => `/social/follow/${userId}`,
      FOLLOW_STATUS: (userId) => `/social/follow/${userId}/status`,
      FOLLOWERS: (userId) => `/social/users/${userId}/followers`,
      FOLLOWING: (userId) => `/social/users/${userId}/following`,
      FOLLOW_COUNTS: (userId) => `/social/users/${userId}/counts`,
      FEED: '/social/feed',
      FEED_TRENDING: '/social/feed/trending',
      FEED_DISCOVER: '/social/feed/discover',
    },
  },

  RAZORPAY_KEY_ID: process.env.REACT_APP_RAZORPAY_KEY_ID || '',

  SOCIAL: {
    GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
    INSTAGRAM_APP_ID: process.env.REACT_APP_INSTAGRAM_APP_ID || '',
    LINKEDIN_CLIENT_ID: process.env.REACT_APP_LINKEDIN_CLIENT_ID || '',
    REDIRECT_URI: process.env.REACT_APP_SOCIAL_REDIRECT_URI || `${window.location.origin}/auth/callback`,
  },

  TIMEOUT: 30000,

  RETRY: {
    MAX_RETRIES: 2,
    BASE_DELAY: 2000,
    RETRY_STATUS_CODES: [408, 502, 503, 504],
  },

  STORAGE_KEYS: {
    ACCESS_TOKEN: 'kridaclub_access_token',
    REFRESH_TOKEN: 'kridaclub_refresh_token',
    USER: 'kridaclub_user',
  },

  PAGINATION: {
    DEFAULT_PAGE: 0,
    DEFAULT_SIZE: 12,
    REGISTRATIONS_SIZE: 20,
    MATCHES_SIZE: 20,
    MEDIA_SIZE: 12,
    REVIEWS_SIZE: 10,
    FEED_SIZE: 10,
    COMMENTS_SIZE: 15,
  },
};

export default API_CONFIG;
